// Standard Library imports
import React, { useEffect, useState } from 'react';
// Css imports
import classes from '../../../../styles/AllDevices.module.css';
import Typography from '../../../../components/Typography/Typography';
import Table from '../../../../components/Table/Table';
import { UilExternalLinkAlt } from '@iconscout/react-unicons';
import IconComponent from '../../../../components/Icon/Icon';

const TOOLS = [
    {
        name: 'mFRR Commands Simulator',
        link: 'http://192.168.56.199:3001',
    },
    {
        name: 'Fortum Temp Solution',
        link: 'http://192.168.56.199:3000',
    },
    {
        name: 'CPO Simulator',
        link: 'http://192.168.56.199:4001',
    },
    {
        name: 'DEV EDX',
        link: 'https://192.168.56.175:9443',
    },
    {
        name: 'DEV ECP',
        link: 'https://192.168.56.175:8443',
    },
    {
        name: 'PROD EDX',
        link: 'https://192.168.56.174:9443',
    },
    {
        name: 'PROD ECP',
        link: 'https://192.168.56.174:8443',
    },
];

export const Tools = ({}) => {
    const [tools, setTools] = useState([]);

    useEffect(() => {
        const processed = TOOLS.map((el, index) => ({
            sno: index + 1,
            name: el.name,
            action: (
                <div onClick={() => window.open(el.link, '_blank')}>
                    <IconComponent icon={UilExternalLinkAlt} tooltip={'Open Tool'} />
                </div>
            ),
        }));

        setTools(processed);
    }, []);

    return (
        <div className={classes.AllDevices}>
            <div className={classes.Header}>
                <div>
                    <Typography content="Tools" />
                </div>
            </div>
            <Table head={['S.No', 'Name', , 'Action']} keys={['sno', 'name', 'action']} data={tools} />
        </div>
    );
};
